import "./ErrorPage.scss";
import React from "react";
import App, {InterfaceAppState} from "../../App";
import {withTranslation} from 'react-i18next';
import {Button} from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

class ErrorPage extends React.Component<{
    AppComp: App, AppState: InterfaceAppState,
    t: any
}, any> {
    constructor(props: any) {
        super(props);

        this.state = {};

    }

    render() {
        const AppState: InterfaceAppState = this.props.AppState;
        const {t} = this.props;

        return (
            <div id="page-error">
                {AppState.catched && <div id="calling-box">
                    <ErrorOutlineIcon color="disabled" style={{fontSize: '100px'}}/>
                    <br/>
                    <span
                        className={"text"}>{AppState.catched.error.message}</span>
                    <span>{AppState.catched.error.cause}</span>
                    {AppState.catched.retry && <div className="controls">
                        <Button onClick={() => {
                            AppState.catched?.retryFunc();
                        }} color="primary" startIcon={<RefreshIcon/>}>{AppState.catched.retryTitle ?
                            AppState.catched.retryTitle : t('back_retry')}</Button>
                    </div>}
                </div>}
            </div>
        );
    }

}

export default withTranslation()(ErrorPage);
